import React, { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import type { Children } from '../../custom-types'
import RulaNav from "../layout-rula/navigation/navigation"
import Delayed from "../transition/delayed"
import Footer from "../layout-rula/footer/footer"
import CookieConsent  from "react-cookie-consent"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import * as E from '../../elementor'

interface Props {
  children: Children | Children[],
  name?: string,
  location: object,
  provider?: boolean,
  ctaColor?: 'amethist' | 'sky' | 'fern' | 'amber',
  ctaLink?: string,
  ctaText?: string,
  experimentA?: boolean,
  customNavBanner?: E.Section,
  emailCaptureSection?: E.Section<true>
  disableNavBanner?: boolean
}

const Layout: React.FC<Props> = ({ children, ...props }) => {
  datadogRum.init({
    applicationId: '02989647-2b8e-4480-ba99-7b0a68dea043',
    clientToken: 'pube7d6cc2a195fbadfefd1dd9569d0b36b',
    site: 'us5.datadoghq.com',
    service: 'marketing-website',
    env: process.env.NODE_ENV === 'development' ? 'development' : 'production',
    sessionSampleRate: 10,
    sessionReplaySampleRate: 20,
    compressIntakeRequests: true,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask'
  })

  return (
    <div className={`layout ${props.name || ''}`}>
      <RulaNav customNavBanner={props.customNavBanner} disableNavBanner={props.disableNavBanner}/>
      <main  className="layout-content">
        <>
          {children}
        </>
      </main>
      <Delayed>
        <CookieConsent
          buttonText={<div>Close</div>}
          disableStyles
          buttonClasses='button-clear button'
          location='none'
        >
          <div className='cookie-consent-content'> 
            <p>
              We've updated our <AniLink fade to='/terms-of-use'>Terms of Use</AniLink> and <AniLink fade to='/privacy-policy/'>Privacy Policy</AniLink>. 
              This site uses cookies to enhance your experience. 
              By continuing to use this site, you agree to our updated policies, including the use of cookies.
            </p>
          </div>
        </CookieConsent>
      </Delayed>
      <Footer experimentA={props.experimentA} emailCaptureSection={props.emailCaptureSection} />
    </div>
  )
}

export default Layout
